import React from 'react';
import { useSelector } from 'react-redux';
import MODAL, { MODAL_THEMES } from 'constants/modals';
import Modal from 'components/Modal';
import { getCurrencyToggleDetails } from 'selectors/currencyToggleSelectors';
import { getDestinationCurrencyCode } from 'selectors/vehicleSelectSelectors';
import TaxesFeesModalContent from 'components/ReservationFlow/VehicleSelect/Modals/TaxesFeesModalContentContainer';
import { i18n } from 'utils/i18n';

const storeKey = 'car_classes';

const TaxesFeesModal = () => {
  const currencyToggleDetails = useSelector((state) => getCurrencyToggleDetails(state, storeKey));
  const isPayTypeSelected = currencyToggleDetails?.isPayTypeSelected;
  const destinationCurrencyCode = useSelector((state) => getDestinationCurrencyCode(state));

  return (
    <Modal
      modalKey={MODAL.TAXES_FEES_MODAL}
      theme={MODAL_THEMES.WHITE}
      headerCloseAriaLabel={`${i18n('vehicle_select_taxes_surcharges_fees')} ${i18n('default_modal_aria_close_label')}`}
    >
      <TaxesFeesModalContent
        describedByID={`${MODAL.TAXES_FEES_MODAL}_desc`}
        destinationCurrencySelected={isPayTypeSelected === destinationCurrencyCode}
      />
    </Modal>
  );
};

export default TaxesFeesModal;
